module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/gift_pile_2-9307220b3896ecda0e5795029c7ab1c2.svg";